import React, { ReactNode, useCallback } from 'react';

import { Tooltip } from 'antd';
import { useTheme } from 'styled-components';

import useCopyToClipboard from '~/hooks/useCopyToClipboard';

import { Container, Label, Value, Icon, ChangedDot } from './styled';

export const CHANGED_FIELD_TOOLTIP = 'Este dado foi alterado entre as versões do contrato.';

type SimpleInfoProps = {
  label?: string;
  value?: string;
  onClick?: (value: any) => void;
  large?: boolean;
  valueColor?: string;
  renderValue?: ReactNode;
  clickable?: boolean;
  disabled?: boolean;
  valueToCopy?: any;
  tooltip?: string;
  changed?: boolean;
};

export default function SimpleInfo({
  label,
  value,
  onClick,
  large,
  valueColor,
  renderValue,
  clickable,
  tooltip,
  disabled,
  changed,
  ...rest
}: SimpleInfoProps) {
  const theme = useTheme();

  const onClickValue = useCallback(() => {
    onClick(value);
  }, [onClick, value]);

  const copyToClipBoard = useCopyToClipboard(rest.valueToCopy || value?.toString());

  return (
    <Container disabled={disabled}>
      {label && (
        <Label>
          {label}
          {changed && (
            <Tooltip placement="top" title={CHANGED_FIELD_TOOLTIP}>
              <ChangedDot data-testid="changed-indicator" />
            </Tooltip>
          )}
        </Label>
      )}
      {renderValue}
      {!renderValue && (
        <Value
          large={large}
          action={onClick}
          color={valueColor}
          clickable={clickable}
          onClick={onClick ? onClickValue : copyToClipBoard}
          {...rest}
        >
          <span>{value?.toString().length ? value : '-'}</span>
          {tooltip ? (
            <Tooltip placement="top" title={tooltip}>
              <Icon type="info-circle" theme="filled" style={{ marginLeft: 10, color: theme.colors.brand.primary }} />
            </Tooltip>
          ) : null}
        </Value>
      )}
    </Container>
  );
}
